// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/container-" + chunkId + "-" + "13a458966631ebcfad0e" + "-3asgoih.chunk.css";
};